export const mobileDisplaySx = (isMobileApp: boolean) => ({
	display: isMobileApp ? 'none' : '',
});
